import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';

import FilterSortBoard from 'webapp/models-custom/filter-sort/board';

export default class FilterSortBoardInGrid extends FilterSortBoard {
	@service('app-notifications') declare appNotificationsService: Service.AppNotifications;

	@tracked override viewId = 'grid';
	override itemDomSelector = 'li.filter-sort-item';

	override get hasItems(): boolean {
		return true; // because we always have the plus to add board
	}
}
